import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { InternalGrid, Text } from '@paygreen/paygreen-ui';
import { CardClassic } from '../../../components';
import UploadLogo from './UploadLogo';

const CharityLogoCard = ({
    t,
    charityDataLocal,
    charityListData,
    setCharityListData,
    isLoading,
}) => (
    <CardClassic
        title={t('charity.charityCard.title')}
        titleSize="md"
        isShadowWab
        blockWidth="md"
    >
        <InternalGrid
            displayType="grid"
            gridTemplateColumns="auto 1fr"
            gridGap="md"
        >
            <UploadLogo
                charityDataLocal={charityDataLocal}
                isLoading={isLoading}
                showButton={false}
            />

            <InternalGrid
                displayType="grid"
                gridGap="sm"
                gridTemplateColumns="1fr"
                justifyItems="start"
            >
                <Text textSize="xs">{t('charity.charityCard.logoText')}</Text>

                <UploadLogo
                    charityDataLocal={charityDataLocal}
                    charityListData={charityListData}
                    setCharityListData={setCharityListData}
                    showLogo={false}
                />
            </InternalGrid>
        </InternalGrid>
    </CardClassic>
);

CharityLogoCard.propTypes = {
    charityDataLocal: PropTypes.object,
    charityListData: PropTypes.array,
    setCharityListData: PropTypes.func,
    isLoading: PropTypes.bool,
};

CharityLogoCard.defaultProps = {
    isLoading: false,
};

export default withTranslation('common')(CharityLogoCard);
